;(function () {
  angular
    .module('contrast.organization-info')
    .controller(
      'OrganizationInfoViewCtrl',
      function (
        $scope,
        GlobalFactory,
        OrganizationFactory,
        ErrorService,
        OrganizationService
      ) {
        'ngInject'

        angular.extend($scope, {
          organization: {}
        })

        function init() {
          loadOrganization()
        }

        function loadOrganization() {
          OrganizationFactory.getOrganization()
            .then(function (response) {
              $scope.organization = OrganizationService.buildOrganization(
                response.data.organization
              )
              loadTimeZones()
              loadDateFormats()
              loadTimeFormats()
            })
            .catch(ErrorService.processError)
        }

        function loadTimeZones() {
          GlobalFactory.getTimeZones()
            .then(function (response) {
              $scope.timezone = _.find(response.data.timezones, {
                name: $scope.organization.timezone
              })
            })
            .catch(ErrorService.processError)
        }

        function loadDateFormats() {
          GlobalFactory.getDateFormats()
            .then(function (response) {
              $scope.date_format = _.find(response.data.date_formats, {
                value: $scope.organization.date_format
              })
            })
            .catch(ErrorService.processError)
        }

        function loadTimeFormats() {
          GlobalFactory.getTimeFormats()
            .then(function (response) {
              $scope.time_format = _.find(response.data.time_formats, {
                value: $scope.organization.time_format
              })
            })
            .catch(ErrorService.processError)
        }

        init()
      }
    )
})()
